module.exports = __webpack_public_path__ + "img/hr-heat-pipe-t-right-1.bae74667.png";